import { BackendResponse, appRegistry, initApi, isActionResponse, version } from 'cdx-common';
import React, { createContext, useContext } from 'react';
import { appStore } from './store';

export interface ApiInterface {
    handleBackendResponse: (data: BackendResponse) => void;
}

const ApiContext = createContext({} as unknown as ApiInterface);

export const wrapHttpHeaders = (headers?: HeadersInit): HeadersInit => {
    return {
        ...(headers ?? {}),
        'Accept': 'application/json',
        'Version': version,
    };
};

const apiJson = async<R,>(url: string, method: string, data?: any, options?: RequestInit) => {
    return new Promise<R>(async (resolve, reject) => {
        const strignifiedData: string | undefined = data ? JSON.stringify(data) : undefined;
        const reqParams = strignifiedData ? {
            method,
            body: strignifiedData,
            ...options,
            headers: wrapHttpHeaders({
                ...options?.headers ?? {},
                'Content-Type': 'application/json',
            }),
        } : {
            method,
            ...options,
            headers: wrapHttpHeaders({
                ...options?.headers ?? {}
            }),
        };
        try {
            fetch(url, reqParams).then(async (result) => {
                if (result.status >= 200 && result.status < 300) {
                    resolve(await result.json());
                } else {
                    reject(result.status);
                }
            }).catch(err => {

                reject(err);
            });
        } catch (error) {
            reject(error);
        }

    });

};

export const initializeApi = () => {
    initApi(
        (url: string, options?: RequestInit) => {
            return apiJson(url, 'GET', undefined, options);
        },
        (url, data, options) => {
            return apiJson(url, 'POST', data, options);
        },
        (url, data, options) => {
            return apiJson(url, 'PUT', data, options);
        },
        (url, options) => {
            return apiJson(url, 'DELETE', undefined, options);
        }
    );
};


export const ApiProvider = (props: { children: React.ReactNode; }) => {

    const handleBackendResponse = (response: BackendResponse) => {

        if (!response) return;
        for (let element of response) {
            if (isActionResponse(element)) {
                console.log('handleBackendResponse dispatch action', element);
                appStore.dispatch(element);
            } else {
                if (element.attrs.length == 1) {
                    const p = appRegistry.get(element.type)?.slice?.actions?.upsertOne(element.attrs[0]);
                    console.log('handleBackendResponse upsertone', element);
                    if (p) appStore.dispatch(p);
                } else if (element.attrs.length > 1) {
                    const p = appRegistry.get(element.type)?.slice?.actions?.upsertMany(element.attrs);
                    console.log('handleBackendResponse upsertmany', element);
                    if (p) appStore.dispatch(p);
                }
            }
        }
    };

    return <ApiContext.Provider value={{ handleBackendResponse }}>{props.children}</ApiContext.Provider>;
};

export const useApi = () => useContext(ApiContext);
